import { customizeValidator } from "@rjsf/validator-ajv8";

import { useState, useRef, useEffect } from "react";
import Form from "@rjsf/core";
import { getUiSchemaIndemnitor } from "../FormBondApp.constants";
import { CustomValidator } from "@rjsf/utils";

export const FormComponent = ({
  isSkipBondIndemnitor,
  setFormDataBondIndemnitor,
  formDataBondIndemnitor,
  submit,
  widgets,
  schema,
  isHideSubmit,
  id,
}: any) => {
  const formIndemnitorsRef = useRef<any>(null);
  const [touchedFields, setTouchedFields] = useState<string[]>([]);

  function transformErrors(errors: any) {
    const filteredErrors = errors.filter((error: any) =>
      touchedFields.includes(error?.property?.replace(".", ""))
    );
    const deletedDublicatesErrors = filteredErrors.reduce(
      (acc: any, item: any) => {
        if (acc?.find((accItem: any) => accItem.property === item.property)) {
          return acc;
        }
        return [...acc, item];
      },
      []
    );

    return deletedDublicatesErrors.map((error: any) => {
      if (error.name === "required") {
        error.message = error.message.replace(/must have required property '(.*)'$/, "'$1' is a required field")
      }
      
      if (error.name === "pattern" || error.name === "format") {
        error.message = `Invalid ${error?.property.replace(".", "")} number`;
        if (error.property.includes("phone")) {
          error.message = `Please enter a valid phone number`;
        }

        if (error.property.includes("email")) {
          error.message = `Please enter a valid email address`;
        }
      }

      return error;
    });
  }

  useEffect(() => {
    setTimeout(() => {
      formIndemnitorsRef?.current?.validateForm();
    }, 0);
  }, [touchedFields]);

  const addAllToTouchedFields = () => {
    setTouchedFields(schema?.required);
  };

  useEffect(() => {
    const submitButton =
      formIndemnitorsRef?.current?.formElement?.current?.getElementsByClassName(
        "submit_button"
      )?.[0];
    submitButton?.addEventListener("click", addAllToTouchedFields);
    return () => {
      return submitButton?.removeEventListener("click", addAllToTouchedFields);
    };
  }, [formIndemnitorsRef]);

  const customFormats = {
    "phone us": /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/,
    "email address":
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    "social security number":
      /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){9,10}(\s*)?$/,
  };

  const validator = customizeValidator({ customFormats });

  const customValidate: CustomValidator<any, any, any> | undefined = (
    formData,
    errors
  ) => {
    if (
      formData?.mailing_zip &&
      !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(formData?.mailing_zip)
    ) {
      errors?.mailing_zip?.addError("Incorrect zip code");
    }
    return errors;
  };

  return (
    <>
      <Form
        ref={formIndemnitorsRef}
        onChange={(e: any) => {
          setFormDataBondIndemnitor((data: any) =>
            (data || []).map((item: any, indemnitorId: number) => {
              if (id === indemnitorId) {
                return e.formData;
              }
              return item;
            })
          );
        }}
        onBlur={(id: any, value) => {
          const fieldName = id.split("root_")[1];

          setTouchedFields((values) => [...values, fieldName]);
        }}
        formData={formDataBondIndemnitor?.[id]}
        schema={isSkipBondIndemnitor ? {} : schema}
        onSubmit={() => {
          if (touchedFields.length !== schema?.required?.length) {
            addAllToTouchedFields();
          } else {
            submit();
          }
        }}
        transformErrors={transformErrors}
        customValidate={customValidate}
        validator={validator}
        widgets={widgets}
        uiSchema={getUiSchemaIndemnitor(isHideSubmit)}
        showErrorList={false}
        noHtml5Validate={true}
        liveValidate
      />
    </>
  );
};
